//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import ProductBox from "../../../component/content/ProductBox";
import Pagination from "../../../component/pagination/Pagination";
import SelectBox from "../../../component/button/SelectBox";

// responsive
import { M, T } from "../../../utils/MT";

// 임시 이미지
import TopBannerJpg from "../../../assets/img/main/top_banner.jpg";
import TopBanner02Jpg from "../../../assets/img/main/main_banner1.jpg";
import ProductImgJpg from "../../../assets/img/picture/product.jpg";

// testData
import { ProductData } from "../../../Data";

export default function Product(props) {
    // 상세페이지 탭 리스트
    const tabData = ["3D PRT", "P1", "K1"];
    const [productTab, setProductTab] = useState([0]);

    // 상품 정렬 필터
    const [filterBoxShow, setFilterBoxShow] = useState(false);
    const [filterSelect, setFilterSelect] = useState(["최근등록순"]);
    const filterList = ["최근등록순", "판매많은순", "낮은가격순", "높은가격순"];

    return (
        <Wrap>
            <Container>
                {/* 탭 ( 신도리코 업체 측 주석처리 요청 ) */}
                {/* <Cate>
                <CateListWrap>
                    {tabData.map((item, index) => {
                        return (
                            <CateList
                                key={index + "banner"}
                                active={productTab == index}
                                onClick={() => {
                                    setProductTab(index);
                                }}
                            >
                                {item}
                            </CateList>
                        );
                    })}
                </CateListWrap>
            </Cate> */}
                {/* 상품 리스트 */}

                <ResultWrap>
                    <TitleWrap>
                        <ContentTitle>{tabData[productTab]}</ContentTitle>
                        <ContentNumText>
                            <ContentNum>30</ContentNum>
                            <ContentText>개의 상품이 있습니다.</ContentText>
                        </ContentNumText>
                    </TitleWrap>

                    {/* 필터 */}
                    <FilterListBigWrap>
                        <SelectBox
                            borderGray={true}
                            orange={true}
                            optionBoxShow={filterBoxShow}
                            setOptionBoxShow={setFilterBoxShow}
                            optionSelect={filterSelect}
                            setOptionSelect={setFilterSelect}
                            optionList={filterList}
                        />
                    </FilterListBigWrap>
                </ResultWrap>
                {/* 리스트 보이는 수 PC = 9개 // MOBILE = 6개 */}
                <ProductListWrap>
                    {ProductData.map((item, index) => {
                        return (
                            <ProductBox
                                key={"productList" + index}
                                id={item.id}
                                productImg={item.productImg}
                                itemName={item.itemName}
                                desc={item.desc}
                                isDiscount={item.isDiscount}
                                orginPrice={item.orginPrice}
                                percent={item.percent}
                                price={item.price}
                                i={item.id}
                            />
                        );
                    })}
                </ProductListWrap>
                {
                    // productDataList.length > 9 &&
                    <PageNationWrap>
                        <Pagination />
                    </PageNationWrap>
                }
            </Container>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;

const Container = styled.section`
    position: relative;
    width: 100%;
`;

const Cate = styled.div`
    width: 100%;
    border-bottom: 1px solid #eee;

    margin-top: calc(100vw * (38 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (38 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(15)};
    }
`;

const CateListWrap = styled.ul`
    display: flex;
    align-items: flex-end;
    justify-content: center;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
        justify-content: space-around;
    }
`;

const CateList = styled.li`
    position: relative;
    min-width: calc(100vw * (72 / 1920));
    padding-bottom: calc(100vw * (33 / 1920));

    font-family: "Pop-M";
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    cursor: pointer;

    &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";

        width: 0;
        height: 2px;
        background: var(--main-color);
    }

    &:not(:first-child) {
        margin-left: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        min-width: calc(100vw * (72 / 1300));
        padding-bottom: calc(100vw * (33 / 1300));

        font-size: calc(100vw * (15 / 1300));

        &:not(:first-child) {
            margin-left: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        min-width: ${M(70)};
        padding: 0 ${M(15)} ${M(10)};

        font-size: ${M(15)};

        &:not(:first-child) {
            margin-left: ${M(10)};
        }
    }

    ${({ active }) => {
        return (
            active &&
            `
            &:after{
                width: 100%;
            }
        `
        );
    }}
`;

const ResultWrap = styled.div`
    display: flex;
    align-items: baseline;

    width: calc(100vw * (1060 / 1920));
    margin: calc(100vw * (90 / 1920)) auto calc(100vw * (54 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: calc(100vw * (90 / 1300)) auto calc(100vw * (54 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        width: ${M(378)};
        margin: ${M(50)} auto ${M(36)};
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 900px) {
        width: 100%;

        margin-bottom: ${M(13)};
    }
`;

const ContentTitle = styled.p`
    font-family: "Pop-M";
    font-size: calc(100vw * (45 / 1920));

    margin-right: calc(100vw * (29 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (45 / 1300));

        margin-right: calc(100vw * (29 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-right: ${M(20)};
    }
`;

const ContentNumText = styled.p`
    display: flex;
    align-items: center;
`;

const ContentText = styled.span`
    display: flex;
    align-items: center;
    font-size: calc(100vw * (16 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const ContentNum = styled.span`
    font: calc(100vw * (20 / 1920)) "Pop-M";

    color: var(--main-color);
    margin-right: calc(100vw * (6 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (6 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: 0;
    }
`;

const FilterListBigWrap = styled.div`
    position: relative;
    width: calc(100vw * (180 / 1920));
    align-self: center;
    margin-left: auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(140)};
    }
`;

const ProductListWrap = styled.ul`
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto calc(100vw * (60 / 1920));

    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: 0 auto calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto ${M(60)};
    }
`;

const PageNationWrap = styled.div`
    text-align: center;

    margin-bottom: calc(100vw * (200 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(100)};
    }
`;
